"use client";

import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import GroupIcon from "@mui/icons-material/Group";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CheckIcon from "@mui/icons-material/Check";

function StepItem({ label, Icon, active, completed }) {
  const circleClasses = completed
    ? "bg-blue text-white-1"
    : active
    ? "bg-blue text-white-1 ring-4 ring-blue-300"
    : "bg-gray-200 text-gray-600";

  const labelClasses = completed
    ? "text-blue"
    : active
    ? "text-blue"
    : "text-gray-500";

  return (
    <div className="flex flex-col items-center relative z-10 space-x-3.5 md:space-x-0">
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${circleClasses}`}
      >
        {completed ? (
          <CheckIcon className="w-5 h-5" />
        ) : (
          <Icon className="w-5 h-5" />
        )}
      </div>
      <span
        className={`mt-2 text-xs sm:text-sm whitespace-nowrap font-bold text-center ${labelClasses}`}
      >
        {label}
      </span>
    </div>
  );
}

export default function ProgressBar({ currentStep }) {
  const steps = [
    { label: "General Info", icon: PersonIcon },
    { label: "Race Details", icon: DirectionsRunIcon },
    { label: "Team/Individual", icon: GroupIcon },
    { label: "Payment", icon: CreditCardIcon },
  ];

  return (
    <div className="flex items-center w-full relative">
      {/* Full-width base line behind all steps */}
      <div className="absolute top-5 left-5 right-5 h-1 bg-gray-200 z-0" />

      {/* Progress line */}
      <div
        className="absolute top-5 left-6 h-1 bg-blue z-0 transition-all"
        style={{
          width: `calc(${
            ((currentStep - 1) / (steps.length - 1)) * 100
          }% - 24px)`,
        }}
      />

      {steps.map((step, idx) => {
        const stepNumber = idx + 1;
        const completed = currentStep > stepNumber;
        const active = currentStep === stepNumber;

        const stepContainerClass =
          idx === steps.length - 1
            ? "flex items-center"
            : "flex-1 flex items-center";

        return (
          <div key={idx} className={stepContainerClass}>
            <StepItem
              label={step.label}
              Icon={step.icon}
              active={active}
              completed={completed}
            />
          </div>
        );
      })}
    </div>
  );
}
